import React ,{useState,useEffect} from 'react';
import Foundationnavbar from '../Components/Foundationnavbar';
import Foundationsidebar from '../Components/Foundationsidebar';
import {Link} from 'react-router-dom'
import FoundEditPopMain from '../Components/FoundEditPopMain';
const FoundEditPop = () => {
    const[sidebar,setSidebarOpen]= useState(false);

    const togglesidebar =()=> {
      setSidebarOpen((prevState) => !prevState)
    }

    useEffect(()=>{const venture = localStorage.getItem('ventureid');

    let FOUNDcheck = venture.includes('04')
     
      if(FOUNDcheck==true){
        document.getElementById("Found-dashboard").style.display="grid"
      }
      else{
        document.getElementById("Found-dashboard").style.display="none"
      
    }
   
   },[]);

   function toggleLogout(){

    document.getElementById("modalLogoutForm").style.display = "block";

   }

   
   function Confirm() {

       
    localStorage.clear();


  }

  function Cancel() {

    document.getElementById("modalLogoutForm").style.display = "none";
       
    
      }
    
       function closeForm()
    {
       document.getElementById("modalLogoutForm").style.display = "none";
     
     }
    


    return (
    <div className="foundation-container" id="Found-dashboard">
    <Foundationnavbar sidebar={sidebar} openSidebar={togglesidebar}/>
   <Foundationsidebar sidebar={sidebar} openLogout={toggleLogout} />
   <FoundEditPopMain/>
   <div className="foundation-pop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-0">
            <div className='text-center'>
          <h5>Are you sure want to logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="foundation-deleteuser-button" onClick={Confirm} type='submit'>Confirm</button></Link>
        <button className="foundation-deleteuser-button" onClick={Cancel} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>
 </div>
  );
    
}

export default FoundEditPop